import React, { FC } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface Props {
  title: string;
  name: string;
  id: string;
  sandbox?: string;
  src?: string;
  srcDoc?: string;
  overrideStyles?: {
    width?: string;
    height?: string;
    border?: string;
  };
  lockScrolling?: boolean;
}

const IFrame: FC<Props> = props => {
  const {
    title,
    name,
    id,
    sandbox,
    src,
    srcDoc,
    overrideStyles,
    lockScrolling,
  } = props;

  return (
    <iframe
      width="100%"
      height={
        overrideStyles && overrideStyles.height ? overrideStyles.height : '100%'
      }
      style={{
        border:
          overrideStyles && overrideStyles.border ? overrideStyles.border : '0',
      }}
      title={title}
      name={name}
      id={id}
      sandbox={sandbox}
      src={src}
      srcDoc={srcDoc}
      scrolling={(lockScrolling && 'no') || 'yes'}
    ></iframe>
  );
};

export default injectSheet(styleSheet)(IFrame);
